import { createFileRoute, Link } from "@tanstack/react-router";
import { buttonVariants } from "@/components/ui/button";

export const Route = createFileRoute("/_home/waitlist/joined")({
  validateSearch: (search: Record<string, unknown>) => ({
    email: typeof search.email === "string" ? search.email : undefined,
  }),
  component: WaitlistJoinedPage,
});

function WaitlistJoinedPage() {
  const { email } = Route.useSearch();

  return (
    <Dialog title="Waitlist Confirmed">
      <Line prefix="+" className="text-emerald-400">
        You're on the waitlist{email ? ` - ${email}` : "."}
      </Line>
      <Blank />
      <Line prefix="$" className="text-muted-foreground">
        Thanks for joining. We'll keep you updated as early access opens up.
      </Line>
      <Blank />
      <Line prefix="#" className="text-muted-foreground/60 text-xs">
        Expect product updates, launch news, and an invite as soon as your spot
        is ready.
      </Line>
      <Blank />
      <div className="flex justify-end gap-3 pl-6">
        <Link to="/" className={buttonVariants()}>
          [back home]
        </Link>
      </div>
    </Dialog>
  );
}

function Dialog({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <div className="relative flex flex-1 flex-col items-center justify-start overflow-hidden px-4 pt-[25vh] sm:px-6">
      <div className="w-full max-w-lg overflow-hidden rounded border border-border/80 shadow-[0_24px_80px_rgba(2,6,23,0.5)]">
        <div className="flex items-center gap-2 border-b border-border/60 bg-card/90 px-4 py-2.5 backdrop-blur">
          <span className="flex-1 text-center font-mono text-xs tracking-wide text-muted-foreground">
            {title}
          </span>
        </div>
        <div className="space-y-1.5 bg-[rgba(2,6,23,0.85)] px-5 py-6 font-mono text-sm leading-relaxed backdrop-blur sm:px-6">
          {children}
        </div>
      </div>
    </div>
  );
}

function Line({
  prefix,
  className,
  children,
}: {
  prefix: string;
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={`flex gap-2 ${className ?? ""}`}>
      <span className="w-4 shrink-0 text-right text-muted-foreground/60">
        {prefix}
      </span>
      <span>{children}</span>
    </div>
  );
}

function Blank() {
  return <div className="h-1.5" />;
}
